var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Grid, Typography } from '@mui/material';
import React from 'react';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import { notificationFooterDate, toggleButtonClass } from '../../constants';
var captionStyle = {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '20px',
    fontStyle: 'normal',
};
var sx = {
    toggleBtn: {
        cursor: 'pointer',
    },
    dateCaption: __assign(__assign({}, captionStyle), { color: function (theme) { return theme.palette.grey[500]; } }),
    actionCaption: __assign(__assign({}, captionStyle), { color: function (theme) { return theme.palette.grey[700]; } }),
};
export var NotificationCardFooter = function (props) {
    var isOpen = props.isOpen, needCollapse = props.needCollapse, toggleMessage = props.toggleMessage, created = props.created;
    var messageId = isOpen ? 'notification.collapse' : 'notification.expand';
    var defaultMessage = isOpen ? 'Свернуть' : 'Развернуть';
    return (React.createElement(Grid, { container: true, justifyContent: "space-between", alignItems: "flex-end" },
        React.createElement(Grid, { item: true },
            React.createElement(Typography, { sx: sx.dateCaption, className: notificationFooterDate },
                React.createElement(FormattedTime, { value: created }),
                " ",
                React.createElement(FormattedDate, { value: created }))),
        needCollapse && (React.createElement(Grid, { item: true, sx: sx.toggleBtn, className: toggleButtonClass, onClick: toggleMessage },
            React.createElement(Typography, { sx: sx.actionCaption },
                React.createElement(FormattedMessage, { id: messageId, defaultMessage: defaultMessage }))))));
};
